import React from "react";
import { Box, Grid, Typography, Container } from "@mui/material";
import feature from "../images/Artboard 1.png";
import fastperformance from "../images/fast-performance.png";
import prototype from "../images/prototype.png";
import vector from "../images/vector.png";
import { Fade } from "react-reveal";

const FeaturesSection = () => {
  const features = [
    {
      title: "Fast performance",
      description: "Our app ensures fast performance, delivering quick insights and smooth navigation for financial consultants.",
      image: fastperformance,
      color: "#FFF",
    },
    {
      title: "Financial Analytics ",
      description: "Our app provides powerful financial analytics to help consultants make data-driven decisions and optimize client strategies.",
      image: prototype,
      color: "#FFF",
    },
    {
      title: "User-friendly Interface",
      description: "Navigate and operate the app seamlessly with an intuitive design.",
      image: vector,
      color: "#FFF",
    },
  ];

  return (
    <Box component="section" id="features" py={5}>
      <Container maxWidth="lg">
        <Grid container alignItems="center" spacing={4}>
          {/* Left Image Section */}
          <Grid
            item
            xs={12}
            md={5}
            lg={6}
            order={{ xs: 2, md: 1 }}
            textAlign={{ xs: "center", md: "left" }}
          >
            <Box
              component="img"
              src={feature}
              alt="Feature Background"
              sx={{ maxWidth: "100%", width: 550 }}
            />
          </Grid>

          {/* Right Text Section */}
          <Grid item xs={12} md={7} lg={6} order={{ xs: 1, md: 2 }}>
            <Typography
              variant="h4"
              sx={{ fontSize: "2.5rem", fontWeight: "bold", mb: 4, }}
            >
              Awesome apps <br />
              features
            </Typography>
            <Typography variant="body1" paragraph >
              Our app combines advanced features like analytics, client management,
              and investment tracking into an awesome, user-friendly platform
            </Typography>

            {/* Feature Items with staggered Fade */}
            {features.map((feature, index) => (
              <Fade
                key={index}
                bottom
                delay={index * 300}
                duration={600}
                cascade={false}
                reset
              >
                <Box display="flex" alignItems="center" mb={5}>
                  <Box
                    component="img"
                    src={feature.image}
                    alt={feature.title}
                    sx={{ width: 70, height: "auto", flexShrink: 0 }}
                  />
                  <Box pl={4}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={feature.color}
                      gutterBottom
                    >
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>
              </Fade>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
